import {Injectable} from '@angular/core';
import {ConfigService} from './config.service';
import {HttpClient} from '@angular/common/http';
import {AbstractSettingsService} from './abstract-settings.service';
import {Profession} from '../model/profession.model';

@Injectable()
export class ProfessionService extends AbstractSettingsService {
    constructor(httpClient: HttpClient, configService: ConfigService) {
        super(httpClient, configService);
    }

    public async getAllProfessions(): Promise<Profession[]> {
        const settings = await this.getSettings();
        return settings.profession.map(p => (<Profession>{name: p.name, employeeType: p.employeeType}));
    }
}